export default {
  new_task: 'NEW TASK',
  in_annotation: 'IN ANNOTATION',
  training: 'TRAINING',
  failed: 'FAILED',
  trained: 'TRAINED',
};
